/**
 * Array<{title: string, path: string}>
 */
const nav = [];
/*
nav.push({
	title: 'Home',
	path: '/'
});
*/
export default nav;


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/nav.js